
import {
  UilUsersAlt,
  UilUserArrows,
  UilEstate,
  UilMoneyBill,
  UilProcess,
  UilUserCheck,
  UilUserTimes,
  UilSuitcaseAlt,
  UilLuggageCart,
  UilUniversity,
  UilCoins,
  UilTransaction,
  UilTruck,
  UilUserPlus,
  UilFileContractDollar,
  UilFileMedicalAlt,
  UilFileAlt,
  UilMoneyStack,
  UilFile,
  UilAngleDown
} from "@iconscout/react-unicons";

export const CustomersSideBarData = [
    {
      icon: UilSuitcaseAlt,
      content: <>Switch Organization <UilAngleDown/></>,
    },
    {
      icon: UilEstate,
      content: "Dashboard",
    },
  {
    head:"CUSTOMERS",
    icon: UilUsersAlt,
    content:"Users",
  },
  {
    icon: UilUserArrows,
    content: "Guarantors",
  },
  {
    icon: UilMoneyBill,
    content: "Loans",
  },
  {
    icon: UilProcess,
    content: "Decision Making",
  },
  {
    icon: UilUserCheck,
    content: "Whitelist",
  },
  {
    icon: UilUserTimes,
    content: "Karma",
  },
  {
    head:"BUSINESSES",
    icon:UilSuitcaseAlt,
    content:"Organization"
},
{
    icon:UilLuggageCart,
    content:"Loan Products"
},
{
    icon:UilUniversity,
    content:"Savings Products"
},
{
    icon:UilCoins,
    content:"Fees and Charges"
},
{
    icon:UilTransaction,
    content:"Transactions"
},
{
    icon:UilTruck,
    content:"Services"
},
{
    icon:UilUserPlus,
    content:"Service Account"
},
{
    icon:UilFileContractDollar,
    content:"Settlement"
},
{
    icon:UilFileMedicalAlt,
    content:"Reports"
},
{
    head:"SETTINGS",
    icon:UilFileAlt,
    content:"Preferences" 
},
{
    icon:UilMoneyStack,
    content:"Fees and Pricing" 
},
{
    icon:UilFile,
    content:"Audit Logs" 
},
];
export const CardInfo=[
    {
        icon:UilUsersAlt,
        iconColor:"#DF18FF",
        iconBgc:"#e018ff30",
        title:"USERS",
        total:"2,433"
    },
    {
        icon:UilUserArrows,
        iconColor:"#5718FF",
        iconBgc:"#5718FF30",
        title:"ACTIVE USERS",
        total:"2,433"
    },
    {
        icon:UilFileContractDollar,
        iconColor:"#F55F44",
        iconBgc:"#F55F4430",
        title:"USERS WITH LOANS",
        total:"12,433"
    },
    {
        icon:UilCoins,
        iconColor:"#FF3366",
        iconBgc:"#FF336630",
        title:"USERS WITH SAVINGS",
        total:"102,433"
    },
    
]

